import { Component, forwardRef } from "@angular/core";
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ListPickerControlComponent } from "../../list-picker/form/list-picker-control.component";
import { ListPickerProviderService } from "../../list-picker/form/list-picker-provider.service";
import { LIST_DEFINITIONS } from "../../list-picker/list-definition";
import { FormHelper } from "../../../pages/form/form-helper";

@Component({
    selector: "userlistpicker",
    template: `
        <ion-item>
            <ion-label
                ngClass="listpicker-value"
                item-content
            >
                {{displayValue}}
            </ion-label>
            <button
                ion-button
                item-right
                item-content
                ngClass="showListPicker"
                (click)="onShowListPicker()"
            >
                Pick
            </button>
            <button
                ion-button
                item-right
                item-content
                color="danger"
                (click)="onClear()"
            >
                X
            </button>

        </ion-item>
    `,
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => UserListPickerControlComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => UserListPickerControlComponent), multi: true}
    ],
    viewProviders: [
        ListPickerProviderService
    ]
})
export class UserListPickerControlComponent extends ListPickerControlComponent {

    ngOnInit(): void {
        super.ngOnInit();
        this.listProvider = this.controller.getProvider(LIST_DEFINITIONS.USER);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/user-list-picker/form/user-list-picker-control.component.ts